import { Title } from "@mantine/core";

const PageNotFound = () => {
  return <Title order={3}>Oops! This Page does not exist.</Title>;
};

export default PageNotFound
